<template>
    <div>
        <!--General Top Bar -->
        <!-- <general-top-bar :title="$t('dispath.drivers')"></general-top-bar> -->
        <!--End General Top Bar -->
        <div class="card driver mar-to-15">
          <div class="card-content">
            <el-table
              v-loading="loading"
              :data="drivers"
              @sort-change="handleSortChange"
            >
              <el-table-column
                prop="name"
                :label="$t('reports.name')"
              >
                <template slot-scope="scope">
                  {{ scope.row.name }}
                </template>
              </el-table-column>
              <el-table-column
                prop="email"
                label="ID"
              >
                <template slot-scope="scope">
                  {{ scope.row.email }}
                </template>
              </el-table-column>
              <el-table-column
                prop="status"
                label="Status"
                sortable
              >
                <template slot-scope="scope">
                  <div :class="getStatusClass(scope.row.status)">
                    {{ scope.row.status }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                prop="driver_schedule_active"
                :label="$t('reports.timerApp')"
                sortable
              >
                <template slot-scope="scope">
                  <div :class="scope.row.driver_schedule_active ? 'online' : 'offline'">
                    {{ scope.row.driver_schedule_active ? 'Active' : 'Inactive' }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                :label="$t('general.wallet')"
                prop="driver_wallet"
                sortable
              >
                <template slot-scope="scope">
                  {{ scope.row.driver_wallet }} {{ currencyIso }}
                </template>
              </el-table-column>
              <el-table-column
                :width="200">
                <template slot-scope="props">
                  <button class="btn add" @click="openAddToWalletModal(props.row)" :title="$t('general.wallet')">
                    <img src="/static/img/icons/add.png">
                    {{ $t('general.wallet') }}
                  </button>
                </template>
              </el-table-column>
              <el-table-column
                :width="200">
                <template slot-scope="props">
                  <a class="delete" @click="openRemoveToWalletModal(props.row)">
                    <img src="/static/img/icons/icon-close.png">
                    {{ $t('general.walletRemove') }}
                  </a>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
    </div>
</template>

  <script>
  // import GeneralTopBar from 'src/components/UIComponents/Inputs/generalTopBar.vue'
  import swal from 'sweetalert2'

  export default {
    components: {
      // GeneralTopBar
    },
    data () {
      return {
        drivers: [],
        sortedDrivers: [],
        loading: false
      }
    },
    mounted () {
      this.getDriversStatus()
    },
    methods: {
      getDriversStatus () {
        this.loading = true
        const dataToSend = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany')
        }
        this.apiRequest('/get-drivers-status', 'GET', dataToSend, (response) => {
          this.loading = false
          if (response.status === true) {
            this.currencyIso = response.data.currency_iso
            this.drivers = response.data.locations.map(driver => ({
              id: driver.id,
              name: `${driver.firstname} ${driver.lastname}`,
              email: driver.email,
              status: driver.is_online ? 'Online' : 'Offline',
              driver_schedule_active: driver.driver_schedule_active,
              driver_wallet: driver.driver_wallet || 0
            }))
            // Salvează driverii în sesiune
            this.$session.set('drivers', this.drivers)
          } else {
            console.error('Failed to fetch offline drivers:', response.message)
          }
        })
      },
      getStatusClass (status) {
        return status === 'Online' ? 'online' : 'offline'
      },
      handleSortChange ({ column, prop, order }) {
        if (prop === 'status') {
          // Sortare personalizată pentru status
          this.sortedDrivers.sort((a, b) => {
            if (order === 'ascending') {
              return a.status === 'Online' ? -1 : 1
            } else {
              return a.status === 'Online' ? 1 : -1
            }
          })
        }
      },
      openAddToWalletModal (driver) {
        swal({
          title: this.$t('general.walletAdd'),
          text: `${this.$t('general.walletAddFor')} ${driver.name}:`,
          input: 'text',
          inputPlaceholder: this.$t('general.walletPlaceholder'),
          showCancelButton: true,
          reverseButtons: true,
          confirmButtonText: this.$t('general.add'),
          cancelButtonText: this.$t('general.cancel')
        }).then((result) => {
          if (result) {
            const amount = parseFloat(result.replace(/[^\d.-]/g, ''))
            if (isNaN(amount) || amount < 0) {
              swal({
                title: 'Error',
                text: this.$t('general.invalidAmount'),
                type: 'error',
                timer: 1500,
                showConfirmButton: false
              })
              return
            }
            const dataToSend = {
              user_id: driver.id,
              amount: amount,
              token: this.$session.get('token')
            }
            this.apiRequest('/add-to-wallet', 'POST', dataToSend, (response) => {
              if (response.status === true) {
                const driverWallet = response.data.user.driver_wallet

                // Update the driver in the drivers array
                const updatedDrivers = this.drivers.map(d => {
                  if (d.id === driver.id) {
                    return { ...d, driver_wallet: driverWallet }
                  }
                  return d
                })

                this.drivers = updatedDrivers

                swal({
                  title: 'Succes',
                  text: this.$t('general.walletSuccess'),
                  type: 'success',
                  timer: 1500,
                  showConfirmButton: false
                })
              } else {
                swal({
                  title: 'Error',
                  text: this.$t('general.walletError'),
                  type: 'error',
                  timer: 1500,
                  showConfirmButton: false
                })
              }
            })
          }
        })
      },
      openRemoveToWalletModal (driver) {
        swal({
          title: this.$t('general.walletRemove'),
          text: `${this.$t('general.walletRemoveFor')} ${driver.name}:`,
          input: 'text',
          inputPlaceholder: this.$t('general.walletPlaceholder'),
          showCancelButton: true,
          reverseButtons: true,
          confirmButtonText: this.$t('general.remove'),
          cancelButtonText: this.$t('general.cancel')
        }).then((result) => {
          if (result) {
            const amount = parseFloat(result.replace(/[^\d.-]/g, ''))
            if (isNaN(amount) || amount < 0) {
              swal({
                title: 'Error',
                text: this.$t('general.invalidAmount'),
                type: 'error',
                timer: 1500,
                showConfirmButton: false
              })
              return
            }

            if (amount > driver.driver_wallet) {
              swal({
                title: 'Error',
                text: this.$t('general.amountExceedsBalance'),
                type: 'error',
                timer: 1500,
                showConfirmButton: false
              })
              return
            }

            const dataToSend = {
              user_id: driver.id,
              amount: amount,
              token: this.$session.get('token')
            }

            this.apiRequest('/reset-wallet', 'POST', dataToSend, (response) => {
              if (response.status === true) {
                const driverWallet = response.data.user.driver_wallet

                // Update the driver in the drivers array
                const updatedDrivers = this.drivers.map(d => {
                  if (d.id === driver.id) {
                    return { ...d, driver_wallet: driverWallet }
                  }
                  return d
                })

                this.drivers = updatedDrivers

                swal({
                  title: 'Success',
                  text: this.$t('general.walletRemoved'),
                  type: 'success',
                  timer: 1500,
                  showConfirmButton: false
                })
              } else {
                swal({
                  title: 'Error',
                  text: this.$t('general.walletRemovalError'),
                  type: 'error',
                  timer: 1500,
                  showConfirmButton: false
                })
              }
            })
          }
        })
      }
    }
  }
  </script>

  <style>
  .el-table .cell {
    height: 55px;
  }
  .online {
    color: rgb(31, 192, 148) !important;
    font-weight: 500;
  }

  .offline {
    color: rgb(255, 77, 77) !important;
    font-weight: 500;
  }
  button.add {
    padding: 5px 15px !important;
  }
  .driver a.delete {
    width: auto;
    line-height: 21px;
    height: 40px;
  }
  </style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Dispatch/DispatchDrivers.vue